<template>
  <div>
    <!-- VISTA DE RESUMEN -->
    <div v-if="onMainView">
      <vx-card class="mt-3">
        <div class="vx-row">
          <div class="vx-col xxl:w-3/4 w-full">
            <div class="mb-4">
              <div class="flex flex-wrap items-center">
                <p class="card-sub-title mr-3">
                  Reinversión Automática
                </p>
                <vs-switch color="primary" :disabled="true" v-model="autoInvestPayments" @change="onAutoInvestChanged()" />
              </div>
              <!--small>(Inversión de pagos recibidos)</small-->
            </div>
            <p>
              Al activar esta función podrás reinvertir automáticamente los ingresos mensuales que recibas de los proyectos en los que
              invertiste previamente y que ya están generando rendimientos. No olvides definir el monto mínimo y máximo de reinversión.
            </p>
          </div>
        </div>
      </vx-card>


      <!-- INVERSION AUTOMATICA CON CARGO A TARJETA -->
      <vx-card class="mt-5">
        <div class="vx-row">
          <div class="vx-col xxl:w-3/4 w-full">
            <div class="mb-4">
              <div class="flex flex-wrap items-center">
                <p class="card-sub-title mr-3">
                  Inversión Automática
                </p>
                <vs-switch color="primary" :disabled="true" v-model="monthlyAutoInvest" @change="onMonthlyAutoInvestChanged" />
              </div>
              <!--small>(Cargo mensual a tarjeta de crédito/débito)</small-->
            </div>
            <p>
              Al activar esta función podrás automatizar el abono de fondos a tu cuenta desde una tarjeta de débito para que
              se inviertan automáticamente en los proyectos que se encuentren en fondeo.
              Elige el monto, día del mes y número de intentos para el cargo.
            </p>
          </div>
        </div>

        <div class="vx-row mt-4" v-if="monthlyAutoInvest">
          <div class="vx-col w-full">
            <vs-button class="ml-auto mt-2" @click="setMonthlyInvest">Ver</vs-button>
          </div>
        </div>
      </vx-card>
      <!-- FIN INVERSION AUTOMATICA CON CARGO A TARJETA -->

      <vx-card class="mt-5" :class="{disabled: !investmentPrefsActive}">
        <div class="vx-row">
          <div class="vx-col xxl:w-3/4 w-full">
            <div class="mb-4">
              <div class="flex flex-wrap items-center">
                <p class="card-sub-title mr-3">
                  Monto Automatizado
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col xxl:w-3/4 w-full">
            <p>
              Puedes disminuir o aumentar la cantidad conforme a lo que decidas realizar con tus fondos. Recuerda que el
              <span class="bold">Monto Automatizado</span> es parte de tu Saldo Disponible, por lo que podrás retirarlo o invertirlo manualmente en el momento en que lo consideres.
            </p>
            <p class="mt-4 mb-1"><span class="bold">Monto Automatizado actual: </span> {{explicitMoneyFormat(availableMoney)}} </p>
            <p class="mt-1 mb-4"><span class="bold">Saldo disponible: </span> {{explicitMoneyFormat(finalBalance)}} </p>
            <p>El valor asignado al <span class="bold">Monto Automatizado</span> para inversión no podrá exceder de tu Saldo Disponible.</p>
          </div>
        </div>
      </vx-card>

      <vx-card class="mt-5" :class="{disabled: !investmentPrefsActive}">
        <div class="vx-row">
          <div class="vx-col xxl:w-3/4 w-full">
            <div class="mb-4">
              <div class="flex flex-wrap items-center">
                <p class="card-sub-title mr-3">
                  Criterios de inversión
                </p>
              </div>
            </div>
            <p>Al momento de activar la inversión o reinversión automática encontrarás en este apartado una serie de
              criterios que podrás configurar según tus lineamientos e invertir en los proyectos de tu preferencia.</p>
          </div>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <vs-button id="prefs-btn" v-if="investmentPrefsActive" class="ml-auto mt-2" @click.stop="goToInvestmentPrefs">Ver</vs-button>
            <vs-button v-if="!investmentPrefsActive" color="dark" disabled class="ml-auto mt-2" @click="">Ver</vs-button>
          </div>
        </div>
      </vx-card>

    </div>
    <!-- FIN VISTA DE RESUMEN -->

    <!-- VISTAS DE CONFIGURACION -->
    <div v-if="onSetsView">
      <monthly-auto-invest
        v-if="onMonthInvestSubview"
        :investor-plan="investorPlan"
        @on-saved="onMonthlyInvestSaved"
        @on-cancel="backToMain"
        :investor-id="InvestorId"
        :user-id="UserId"
      />
    </div>
    <!-- FIN VISTAS DE CONFIGURACION -->
  </div>

</template>

<script>
import MonthlyAutoInvest from "@/views/admin/investor/plans/MonthlyAutoInvest";
import formatHelper from "@mixins/formatHelper";
import investorInfoHelper from "@/helpers/investorInfoHelper";
export default {
  components: {
    MonthlyAutoInvest,
  },
  props: {
    InvestorId: {
      type: [String,Number],
      required: true
    }
  },
  mixins:[formatHelper, investorInfoHelper],
  data(){
    return {
      UserId: null,
      autoInvestPayments: false,
      monthlyAutoInvest: false,
      investLimitsActive: true,

      currentMainView: 0,
      currentSubView: null,
      minAutoInvestPercent: 50,
      maxAutoInvestPercent: 100,

      currentAutoInvestPercent: 100,
      widthx: 60,
      heightx: 60,

      investorPlan: {
        id: null,
        card_id: null,
        card_amount: null,
        reinvestment_percentage: null,
        qualifications: null,
        monthly_day: null,
        available_money: null,
        retry: null,
        min_autoinvest_project_amount_mxn: null,
        max_autoinvest_project_amount_mxn: null,
        autoinvest_applicant_payments: null,
        autoinvest_deposits: null,
      },

      finalBalance: null,
      minAutoInvestMxn: null,
      availableMoney: null,

      isBusy: false,

      tourOptions: {
        labels: {
          buttonSkip: 'Saltar',
          buttonPrevious: 'Anterior',
          buttonNext: 'Siguiente',
          buttonStop: 'Cerrar'
        }
      },

      showTour: false,

      steps: [
        {
          target: '#plan-header-text',
          content: `Busca en la barra de navegación el elemento Monto Automatizado. En este campo podrás consultar el saldo de reinversión o inversión automática`,
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#prefs-btn',
          content: `Define los criterios para tus inversiones automatizadas en este apartado.`,
          params: {
            placement: 'left'
          }
        },
      ]
    }
  },
  async mounted(){
    this.showLoading(true);
    await this.loadPrefs();
    this.showLoading(false);
  },
  methods: {
    async goToInvestmentPrefs(){
      await this.$router.push({name: 'inversionistaCriteriosInversion'});
    },
    percentUpdated(value){
      const v = 60 + ((value - 50) * 0.5);
      this.widthx = this.heightx = v;
    },
    async loadPrefs(){
      await this.getPlansInfo();
      await this.setDefaults();
      const investor = await this.getInvestorData(this.InvestorId, ['user']);
      this.UserId = investor.user_id;
    },
    async getPlansInfo(){
      try {
        const res = await axios.get(`api/v2/investor/${this.InvestorId}/getInvestorPlansInfo`);
        this.investorPlan = res.data.plan;
        this.finalBalance = res.data.finalBalance;
        this.minAutoInvestMxn = res.data.minAutoInvestMxn;
        this.availableMoney = this.investorPlan.available_money;

        if(this.investorPlan.min_autoinvest_project_amount_mxn === null
          || this.investorPlan.min_autoinvest_project_amount_mxn === 0){
          this.investorPlan.min_autoinvest_project_amount_mxn = this.minAutoInvestMxn;
        }

        if(this.investorPlan.max_autoinvest_project_amount_mxn === null){
          this.investorPlan.max_autoinvest_project_amount_mxn = 0;
        }
      }
      catch (e) {
      }
    },
    async onAutoInvestChanged(){
    },
    async onMonthlyAutoInvestChanged(){
    },
    async saveOption(key, val, name){
      this.showLoading(true)
      let success = false;
      try {
        let payload = { option_key: key, option_value: val };
        await axios.post(`api/v2/investor/${this.InvestorId}/setAutoInvestOptions`, payload);
        let mssg = 'La '+ name + ' fue';
        mssg += (val) ? ' habilitada' : ' deshabilitada';
        mssg += ' exitosamente.';
        this.successNotif('¡Listo!', mssg);
        success = true;
      }
      catch (e) {
        this.errorNotif('Error en guardado', 'No ha sido posible actualizar la información');
        success = false;
      }
      finally {
        await this.loadPrefs();
        this.showLoading(false)
        if(this.autoInvestPayments || this.monthlyAutoInvest){
          this.showTour = true;
        }
      }
      return success;
    },

    async setMonthlyInvest(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 1;
    },
    async setAvailableMoney(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 2;
    },
    async setInvestmentLimits(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 3;
    },
    async setProjectQualifications(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 4;
    },

    async onMonthlyInvestSaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },
    async onAvailableMoneySaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },
    async onInvestmentLimitsSaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },
    async onProjectsQualificationsSaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },

    async backToMain(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },

    async setDefaults(){
      this.autoInvestPayments = this.investorPlan.autoinvest_applicant_payments === 1;
      this.monthlyAutoInvest = this.investorPlan.autoinvest_deposits === 1;

      //this.currentAutoInvestPercent = 100;
      //this.percentUpdated(this.currentAutoInvestPercent);
    },
  },
  computed: {
    onMainView(){
      return this.currentMainView === 0;
    },
    onSetsView(){
      return this.currentMainView === 1;
    },
    onMonthInvestSubview(){
      return this.currentSubView === 1;
    },
    onAvailableMoneySubview(){
      return this.currentSubView === 2;
    },
    onInvestmentLimitsSubView(){
      return this.currentSubView === 3;
    },
    onProjectQualificationsSubView(){
      return this.currentSubView === 4;
    },
    investmentPrefsActive(){
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    reinvestmentActive() {
      return this.autoInvestPayments === true;
    },
    cardInvestmentActive() {
      return this.monthlyAutoInvest === true;
    },
    showAvailableMoney(){
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    showInvestmentLimits() {
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    showProjectsQualifSets(){
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    currentAvailableMoneyValue(){
      return this.investorPlan.available_money;
    },
    currentMinLimitValue(){
      return this.investorPlan.min_autoinvest_project_amount_mxn;
    },
    currentMaxLimitValue(){
      return this.investorPlan.max_autoinvest_project_amount_mxn;
    },
  }
}
</script>

<style lang="css">
.cuadrox {
  padding: 10px;
  background: rgb(45, 208, 129);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
  font-size: 20px;
  border-radius: 10px;
}

.vx-card.disabled {
  opacity: 0.4;
}
</style>
